import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export-v2",
  "use": "icon-export-v2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-export-v2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2.667c-.736 0-1.333.597-1.333 1.333v8c0 .737.597 1.334 1.333 1.334h8c.737 0 1.334-.597 1.334-1.334v-1.666a.667.667 0 1 0-1.334 0V12H4V4h1.334a.667.667 0 0 0 0-1.333H4ZM11.057 4h-2.39a.667.667 0 0 1 0-1.333H12c.737 0 1.334.597 1.334 1.333v3.334a.667.667 0 0 1-1.334 0v-2.39L7.472 9.471a.667.667 0 1 1-.943-.943L11.057 4Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol